import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import rootSaga from './rootSaga';

import { formControlReducer } from './formControlSlice/formControlSlice';
import { authReducer } from './authSlice/authSlice';
import { homeReducer } from './homePageSlice/homePageSlice';
import { snackbarsReducer } from './snackbarsSlice/snackbarsSlice';
import { roleMenagmentReducer } from './roleMenagmentSlice/roleMenagmentSlice';
import { addUserReducer } from './addUserSlice/addUserSlice';
import { featureFlagReducer } from 'store/featureFlagSlice/featureFlagSlice';

let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const store = configureStore({
    reducer: {
        forms: formControlReducer,
        auth: authReducer,
        home: homeReducer,
        snackbars: snackbarsReducer,
        roleMenagment: roleMenagmentReducer,
        addUser: addUserReducer,
        featureFlag: featureFlagReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'snackbars/removeSnackbar',
                    'snackbars/removeSnackbar',
                    'roleMenagment/submitFormStart',
                    'addUser/addUsers',
                    'addUser/addUserRoles',
                    'addUser/deleteUserRoles',
                ],
            },
        }).concat(middleware),
});

sagaMiddleware.run(rootSaga);

export default store;
